import React from "react";
import { Grid } from "@mui/material";
import { useIntl } from "react-intl";

import SectionHeader from "@/views/Patient/HealthHub/SectionHeader";
import LongThumbnailCard from "@/views/Patient/HealthHub/VideoPlaylistSection/LongThumbnailCard";
import ShortThumbnailCard from "@/views/Patient/HealthHub/VideoPlaylistSection/ShotThumbnailCard";
import ScrollContainer from "@/views/Patient/HealthHub/ScrollContainer";
import SectionContainer from "@/views/Patient/HealthHub/SectionContainer";

import style from "./index.module.css";

import {
  IHealthHubPlaylistResult,
  IHealthHubPlaylistVideoType,
  IHealthHubPlaylistVideoTypeUpperCase,
} from "@/models/ApiRequestResponse/patient";

type VideoPlayListSectionProps = {
  data: IHealthHubPlaylistResult;
  className?: string;
  isSection?: boolean;
  isFavouriteCategory?: boolean;
};

const VideoPlayListSection: React.FC<VideoPlayListSectionProps> = ({
  data,
  className,
  isSection = true,
  isFavouriteCategory = false,
}) => {
  const intl = useIntl();
  const isShortVideoPlaylist = data.data.some(
    (video) =>
      video.type === IHealthHubPlaylistVideoType.SHORT ||
      video.type === IHealthHubPlaylistVideoTypeUpperCase.SHORT
  );

  const title =
    isShortVideoPlaylist && isFavouriteCategory
      ? "Favourites Shorts"
      : isFavouriteCategory && !isShortVideoPlaylist
      ? "Favourites Videos"
      : data.name;

  return (
    <SectionContainer isSection={isSection}>
      <Grid
        className={`${style.outerContainer} ${className}`}
        sx={{
          padding: { xs: "0 0.5rem", sm: "0.2rem 0" },
          // ml: { xs: "1rem", sm: "4rem", md: "11rem" },
          maxWidth: { xs: "95%", sm: "100%" },
        }}
      >
        <SectionHeader
          title={title}
          subtitle={`${data.data.length} ${
            data.data.length === 1
              ? intl.formatMessage({
                  id: "video",
                  defaultMessage: "Video",
                })
              : intl.formatMessage({
                  id: "videos",
                  defaultMessage: "Videos",
                })
          }`}
        />
        <ScrollContainer isSection={isSection}>
          {data.data.map((video) => {
            return video.type === IHealthHubPlaylistVideoType.LONG ||
              video.type === IHealthHubPlaylistVideoTypeUpperCase.LONG ? (
              <LongThumbnailCard key={video.id} video={video} />
            ) : (
              <ShortThumbnailCard key={video.id} video={video} />
            );
          })}
        </ScrollContainer>
      </Grid>
    </SectionContainer>
  );
};

export default VideoPlayListSection;
